<script>
import { formRenderMixin } from '@/mixins/formRender';

// @vuese
// Komponent generujący odpowiedni wzór formularza
export default {
  components: {
    Duplicates: () => import(/* webpackChunkName: "Duplicates" */ './document/templates/Duplicates.vue'),
    OW003Benefit: () => import(/* webpackChunkName: "OW003Benefit" */ './document/templates/OW-003-Benefit.vue'),
    OW003Benefit2026: () => import(/* webpackChunkName: "OW003Benefit2026" */ './document/templates/OW-003-Benefit-2026.vue'),
    OW003Prezydencki: () =>
      import(/* webpackChunkName: "OW003Prezydencki" */ './document/templates/OW-003-Prezydencki.vue'),
    OW003PrezydenckiAggregate: () =>
      import(
        /* webpackChunkName: "OW003PrezydenckiAggregate" */ './document/templates/OW-003-Prezydencki-Aggregate.vue'
      ),
    OW003PrezydenckiAssessment: () =>
      import(
        /* webpackChunkName: "OW003PrezydenckiAssessment" */ './document/templates/OW-003-Prezydencki-Assessment.vue'
      ),
    OW003PrezydenckiAssessmentDistinction: () =>
      import(
        /* webpackChunkName: "OW003PrezydenckiAssessmentDistinction" */ './document/templates/OW-003-Prezydencki-Assessment.vue'
      ),
    OW003PrezydenckiAssessmentScholarship: () =>
      import(
        /* webpackChunkName: "OW003PrezydenckiAssessmentScholarship" */ './document/templates/OW-003-Prezydencki-Assessment.vue'
      ),
    OW003Scholarship: () =>
      import(/* webpackChunkName: "OW003Scholarship" */ './document/templates/OW-003-Scholarship.vue'),
    OW003Scholarship2026: () =>
      import(/* webpackChunkName: "OW003Scholarship2026" */ './document/templates/OW-003-Scholarship-2026.vue'),
    OW004: () => import(/* webpackChunkName: "OW004" */ './document/templates/OW-004.vue'),
    OW004Announcement: () =>
      import(/* webpackChunkName: "OW004Announcement" */ './document/templates/OW-004-Announcement.vue')
  },
  mixins: [formRenderMixin]
};
</script>
